export default __webpack_public_path__ + "static/media/commonroad_search.d578b0a3.png";